import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ContTitle = styled.div`
  position: relative;
  padding: 0 16px 8px;

  .text {
    text-align: left;
  }

  .title {
    ${mixin.ellipsis(2)};
  }

  .main-title2,
  .main-title {
    display: block;
    font-size: 17px;
    font-weight: 600;
    line-height: 130%;
  }

  .sub-title {
    margin-top: 4px;
    line-height: 130%;
  }

  .btn {
    width: 100%;

    .title {
      width: 100%;
    }

    .btn-more {
      flex-shrink: 0;
      padding-bottom: 3px;
      font-weight: 500;
      font-size: 13px;
      line-height: 130%;
      color: #999;
    }
  }

  .tag-ad {
    flex-shrink: 0;
    font-weight: 500;
    font-size: 12px;
    line-height: 130%;
    color: #999;
    background-color: #f6f6f6;
    padding: 1px 4px;
  }

  .title-enhanced {
    ${mixin.flex({ justify: 'space-between', align: 'flex-end' })};
    column-gap: 12px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('0 16 8')};

    .main-title2,
    .main-title {
      font-size: ${mixin.pxToVw('17')};
    }

    .sub-title {
      margin-top: ${mixin.pxToVw('4')};
    }

    .btn {
      .btn-more {
        padding-bottom: ${mixin.pxToVw('3')};
        font-size: ${mixin.pxToVw('13')};
      }
    }

    .tag-ad {
      font-size: ${mixin.pxToVw('12')};
      padding: ${mixin.pxToVw('1 4')};
    }

    .title-enhanced {
      column-gap: ${mixin.pxToVw('12')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 0 0 16px 0;

    .main-title2,
    .main-title {
      font-size: 26px;
    }

    .sub-title {
      font-size: 15px;
      margin-top: 6px;
    }

    .btn {
      .btn-more {
        padding-bottom: 5px;
        font-size: 16px;
      }
    }

    .tag-ad {
      font-size: 15px;
      padding: 2px 4px;
      transform: translateY(-3px);
    }
  }
`;
